export const siteConfig = {
  name: 'ConciergeUnit',
  owner: 'Belbachir Soufiane',
  tagline: 'Professionelle Empfangsdienstleistungen für Hotellerie & Events',
  description: 'ConciergeUnit bietet professionelle Night-Auditor-Services, Empfangs- und Receptionsservices für die Hotellerie sowie Event-Services. Erfahrung mit Opera, SIHOT, Protel und mehr.',
  url: import.meta.env.VITE_SITE_URL || 'https://conciergeunit.de',
  email: 'info@conciergeunit.de',
  phone: '+49 176 72536937',
  address: {
    street: '', // Wird vom Kunden ergänzt
    city: '',
    zip: '',
    country: 'Deutschland',
  },
};

export function generateMetaTags(options: {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
}) {
  const { 
    title, 
    description = siteConfig.description,
    path = '',
    image = '/images/og-default.jpg'
  } = options;

  const fullTitle = title 
    ? `${title} | ${siteConfig.name}` 
    : `${siteConfig.name} - ${siteConfig.tagline}`;
  
  const url = `${siteConfig.url}${path}`;

  return {
    title: fullTitle,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: url },
      { property: 'og:image', content: `${siteConfig.url}${image}` },
      { property: 'og:site_name', content: siteConfig.name },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: `${siteConfig.url}${image}` },
    ],
    link: [
      { rel: 'canonical', href: url },
    ],
  };
}

// JSON-LD strukturierte Daten
export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    logo: `${siteConfig.url}/logo.jpeg`,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: siteConfig.phone,
      contactType: 'customer service',
      email: siteConfig.email,
      availableLanguage: ['German'],
    },
  };
}

export function generateLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: siteConfig.name,
    description: siteConfig.description,
    provider: {
      '@type': 'Organization',
      name: siteConfig.name,
      telephone: siteConfig.phone,
      email: siteConfig.email,
    },
    areaServed: 'DE',
    serviceType: ['Night-Auditor-Service', 'Receptionsservice', 'Event-Service'],
  };
}
